import * as constants from './constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

// eslint-disable-next-line import/prefer-default-export
export const versionReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_VERSION:
    return { ...state, loading: true };
  case constants.GET_VERSION_SUCCESS: {
    return { ...state, loading: false, data: action.payload };
  }
  case constants.GET_VERSION_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_VERSION:
    return initialState;
  default:
    return state;
  }
};
